import { NgModule } from '@angular/core';
import { SharedModule, addNavMenuSection } from '@vendure/admin-ui/core';
import { Permission } from './generated-types';

@NgModule({
  imports: [SharedModule],
  providers: [
    addNavMenuSection(
      {
        id: 'pages-nav',
        label: 'Static Pages',
        items: [
          {
            id: 'pages',
            label: 'Pages',
            routerLink: ['/extensions/page/pages'],
            icon: 'tags',
            requiresPermission: Permission.ReadPages,
          },
        ],
        requiresPermission: Permission.ReadPages,
      },
      // Add this section before the "settings" section
      'settings'
    ),
  ],
})
export class PagesSharedModule {}
